import { forwardRef } from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgentTwoTone';
import { useAppSelector } from '@reduxStore';
import { getDomain } from '@/Infrastructure/Utilities/domain';
import { NavItemProps } from '../types';
import { AvatarMenuItemProps } from './types';

import styles from '../NavigationBarItem.module.css';

function useContactSupportHref() {
  const terminal = useAppSelector((state) => state.applicationState.selectedTerminal);
  const company = useAppSelector((state) => state.appSettings?.company);
  return `mailto:helpdesk@${getDomain()}?subject=${encodeURIComponent(`Web UI - ${company ?? 'No Company Selected'} ${terminal?.number ?? 'No Terminal Selected'}`)}`;
}

export function ContactSupportListItem({ isDesktopOpen, isMobile }: NavItemProps) {
  const href = useContactSupportHref();

  return (
    <ListItem
      disablePadding
      className={styles['navigation-item']}
      title='Contact Support'>
      <ListItemButton
        component='a'
        href={href}
        className={styles['navigation-item-btn']}>
        <ListItemIcon className={styles['navigation-item-btn-icon']}>
          <SupportAgentIcon />
        </ListItemIcon>
        <ListItemText
          primary='Contact Support'
          slotProps={{
            primary: {
              className: `${styles['navigation-item-btn-text']} ${!isDesktopOpen && !isMobile ? styles.hidden : ''}`,
              variant: 'body1'
            }
          }}
        />
      </ListItemButton>
    </ListItem>
  );
}

export const ContactSupportMenuItem = forwardRef<HTMLAnchorElement, AvatarMenuItemProps<HTMLAnchorElement>>(function ContactSupportMenuItem(
  { textClassName, ...props },
  ref
) {
  const href = useContactSupportHref();

  return (
    <MenuItem
      ref={ref}
      component='a'
      href={href}
      {...props}>
      <ListItemIcon>
        <SupportAgentIcon />
      </ListItemIcon>
      <ListItemText slotProps={{ primary: { className: textClassName } }}>Contact Support</ListItemText>
    </MenuItem>
  );
});
